export const GET_ASSESSMENTS = 'GET_ASSESSMENTS';
export const GET_ASSESSMENTS_SUCCESS = 'GET_ASSESSMENTS_SUCCESS';
export const GET_ASSESSMENTS_FAILURE = 'GET_ASSESSMENTS_FAILURE';

export const GET_ASSESSMENT = 'GET_ASSESSMENT';
export const GET_ASSESSMENT_SUCCESS = 'GET_ASSESSMENT_SUCCESS';
export const GET_ASSESSMENT_FAILURE = 'GET_ASSESSMENT_FAILURE';

export const TOGGLE_FLAG_CURRENT_ANSWER = 'TOGGLE_FLAG_CURRENT_ANSWER';
export const NAVIGATE_TO = 'NAVIGATE_TO';

export const SAVE_CURRENT_ANSWER = 'SAVE_CURRENT_ANSWER';
export const SAVE_NOTES = 'SAVE_NOTES';
export const SAVE_ASSESSMENT_INFO = 'SAVE_ASSESSMENT_INFO';

export const POST_ASSESSMENT = 'POST_ASSESSMENT';
export const PUT_ASSESSMENT = 'PUT_ASSESSMENT';
export const SPLIT_PUT_ASSESSMENT = 'SPLIT_PUT_ASSESSMENT';
export const FORCE_PUT_ASSESSMENT = 'FORCE_PUT_ASSESSMENT';
export const CLEAR_CURRENT_ASSESSMENT = 'CLEAR_CURRENT_ASSESSMENT';
export const UPDATE_CURRENT_ASSESSMENT = 'UPDATE_CURRENT_ASSESSMENT';
export const POST_ASSESSMENT_FAILURE = 'POST_ASSESSMENT_FAILURE';
export const PUT_ASSESSMENT_FAILURE = 'PUT_ASSESSMENT_FAILURE';

export const SELECT_SECTION = 'SELECT_SECTION';

export const UPLOAD_ASSESSMENT = 'UPLOAD_ASSESSMENT';
export const UPLOAD_ASSESSMENT_SUCCESS = 'UPLOAD_ASSESSMENT_SUCCESS';
export const UPLOAD_ASSESSMENT_FAILURE = 'UPLOAD_ASSESSMENT_FAILURE';


export const DOWNLOAD_COMPARISON = 'DOWNLOAD_COMPARISON';
export const DOWNLOAD_COMPARISON_SUCCESS = 'DOWNLOAD_COMPARISON_SUCCESS';
export const DOWNLOAD_COMPARISON_FAILURE = 'DOWNLOAD_COMPARISON_FAILURE';

export const DOWNLOAD_ASSESSMENT = 'DOWNLOAD_ASSESSMENT';
export const DOWNLOAD_ASSESSMENT_SUCCESS = 'DOWNLOAD_ASSESSMENT_SUCCESS';
export const DOWNLOAD_ASSESSMENT_FAILURE = 'DOWNLOAD_ASSESSMENT_FAILURE';



// WEBPACK FOOTER //
// ./src/redux/actions/assessmentsActionTypes.js